var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5134 13.125L42 21V34.125C42 35.8546 41.1251 36.7295 39.375 36.7503H2.625C2.625 36.7503 0 36.7193 0 34.125V21L10.4028 13.125H31.5134ZM10.5 23.625H2.625V34.125L39.3078 34.126L39.375 34.1302L39.3078 23.625H31.5C29.8386 28.875 27.7169 31.5 25.1347 31.5H16.8408C14.1014 31.5 11.9878 28.875 10.5 23.625ZM30.6374 15.75H11.2761L4.50712 21H13.125C13.8408 25.1044 15.4622 28.665 17.9892 28.8603L18.375 28.875H23.625C25.6959 28.8653 27.4459 26.2402 28.875 21H37.464L30.6374 15.75ZM7.30992 6.23934L10.2549 10.5L8.11532 11.9493L5.25 7.875L7.30992 6.23934ZM34.445 6.23934L36.5048 7.875L33.6396 11.9493L31.5 10.5L34.445 6.23934ZM18.375 5.25V10.5H15.75V5.25H18.375ZM26.25 5.25V10.5H23.625V5.25H26.25Z",
    fill: "#D6002A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty-icon.6328c234.svg";
export { ForwardRef as ReactComponent };